module.exports = __webpack_public_path__ + "static/media/services.8cf57e06.jpg";